import React from "react";
import {QueryClient, QueryClientProvider} from "react-query";
import {UserProvider} from "./auth";
import AppThemeProvider from "./theme";
import {SnackbarProvider} from "./snackbar";
import {NotificationsProvider} from "./notifications";
import {WorkspaceProvider} from "./workspace";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
});

const AppProviders: React.FC<{children: React.ReactNode}> = ({children}) => {
  return (
    <QueryClientProvider client={queryClient}>
      <SnackbarProvider>
        <UserProvider>
          <NotificationsProvider>
            <AppThemeProvider>
              <WorkspaceProvider>
                {children}
              </WorkspaceProvider>
            </AppThemeProvider>
          </NotificationsProvider>
        </UserProvider>
      </SnackbarProvider>
    </QueryClientProvider>
  )
}
export {AppProviders}